export default __webpack_public_path__ + "static/media/nft-launchpad.fff5a2d1.png";